import WalletContainer from './WalletHomeContainer';
import WithdrawContainer from './WithdrawContainer';
import NewBeneficiaryContainer from './NewBenefeciaryContainer';
import SavedBeneficiaryContainer from './SavedBeneficiaryContainer';
import TransferContainer from './TransferContainer';
import TransferFundOptionContainer from './TransferOptionContainer';
import TransferPinConfirmationContainer from './TransferPinConfirmationContainer';
import TransferFailedContainer from './TransferFailedContainer';
import TransferSuccessContainer from './TransferSuccessContainer';
import WalletExchangeContainer from './WalletExchangeContainer';
import AccountStatementContainer from './AccountStatementContainer';
import BankAccountReqContainer from './BankAccountReqContainer';

export {
	WalletContainer,
	WithdrawContainer,
	NewBeneficiaryContainer,
	SavedBeneficiaryContainer,
	TransferContainer,
	TransferFundOptionContainer,
	TransferPinConfirmationContainer,
	TransferFailedContainer,
	TransferSuccessContainer,
	WalletExchangeContainer,
	AccountStatementContainer,
	BankAccountReqContainer,
};
